import type { ErpModule } from '@/api/platform.api';
import WorkIcon from '@mui/icons-material/Work';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import type { NavItem } from '@/components/layout/Sidebar';
import { LAUNCHER_ERP_MODULES, moduleSlug } from '@/config/moduleDefaults';

export function moduleWorkPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/work`;
}

export function moduleExecutiveWorkPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/work/executive`;
}

export function moduleApprovalsPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/approvals`;
}

export function moduleApprovalsBuilderPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/approvals/builder`;
}

export function moduleApprovalsMatrixPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/approvals/matrix`;
}

export function moduleApprovalsDelegationsPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/approvals/delegations`;
}

export function moduleNotificationsPath(module: ErpModule): string {
  return `/${moduleSlug(module)}/notifications`;
}

export function moduleWorkRoutes(module: ErpModule): string[] {
  return [
    moduleWorkPath(module),
    moduleExecutiveWorkPath(module),
    moduleApprovalsPath(module),
    moduleApprovalsBuilderPath(module),
    moduleApprovalsMatrixPath(module),
    moduleNotificationsPath(module),
  ];
}

export function allModuleWorkRoutes(): string[] {
  return LAUNCHER_ERP_MODULES.flatMap((mod) => moduleWorkRoutes(mod));
}

/** Legacy global work URLs → module-scoped equivalents. */
export function legacyWorkRedirectTarget(pathname: string, module: ErpModule): string | null {
  const path = pathname.split('?')[0];
  if (path === '/work' || path === '/dashboard/home') return moduleWorkPath(module);
  if (path === '/work/executive') return moduleExecutiveWorkPath(module);
  if (path === '/work/approvals') return moduleApprovalsPath(module);
  if (path === '/approvals/builder') return moduleApprovalsBuilderPath(module);
  if (path === '/approvals/matrix') return moduleApprovalsMatrixPath(module);
  if (path === '/notifications') return moduleNotificationsPath(module);
  return null;
}

/** Work sidebar items scoped to the active module workspace. */
export function getModuleWorkNavItems(module: ErpModule): NavItem[] {
  return [
    { to: moduleWorkPath(module), label: 'My Work', icon: WorkIcon, end: true },
    { to: moduleApprovalsPath(module), label: 'Approval inbox', icon: FactCheckIcon },
    { to: moduleNotificationsPath(module), label: 'Notifications', icon: NotificationsActiveIcon },
    { to: moduleExecutiveWorkPath(module), label: 'Executive view', icon: AnalyticsIcon },
    { to: moduleApprovalsBuilderPath(module), label: 'Approval workflows', icon: FactCheckIcon },
    { to: moduleApprovalsMatrixPath(module), label: 'Approval matrix', icon: AccountTreeIcon },
  ];
}
